import { render, staticRenderFns } from "./PointProd.vue?vue&type=template&id=863883ee&scoped=true"
import script from "./PointProd.vue?vue&type=script&lang=js"
export * from "./PointProd.vue?vue&type=script&lang=js"
import style0 from "./PointProd.vue?vue&type=style&index=0&id=863883ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863883ee",
  null
  
)

export default component.exports